import { render, staticRenderFns } from "./horizontal-tabs.vue?vue&type=template&id=0134fe38&scoped=true&"
import script from "./horizontal-tabs.vue?vue&type=script&lang=js&"
export * from "./horizontal-tabs.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-tabs.vue?vue&type=style&index=0&id=0134fe38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134fe38",
  null
  
)

export default component.exports